import React from 'react';
import { CTAButton } from './CTAButton';
export const FAQSection = () => {
  return <section id="legal" className="w-full bg-gray-50 py-12 px-4" data-id="element-273">
      <div className="max-w-4xl mx-auto" data-id="element-274">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8" data-id="element-275">
          Legal & Disclosures
        </h2>
        <div className="space-y-6 mb-8 text-sm text-gray-600" data-id="element-276">
          <div data-id="element-277">
            <h3 className="font-semibold text-base mb-2 text-teal-700" data-id="element-278">
              Health Disclosure
            </h3>
            <p data-id="element-279">
              This product is not intended to diagnose, treat, cure, or prevent
              any medical condition. Individual results may vary. Always consult
              your healthcare provider regarding any health concerns.
            </p>
          </div>
          <div data-id="element-280">
            <h3 className="font-semibold text-base mb-2 text-teal-700" data-id="element-281">
              Advertising & Testimonial Disclosures
            </h3>
            <p data-id="element-282">
              This page is an advertisement for Ardava. Some customer
              experiences described are representative of feedback we receive;
              names and non‑material details may be changed for privacy. Any
              specialist or expert depictions are actor portrayals and are not
              medical advice. Individual experiences vary. Risk‑free guarantee
              and sizing/exchange policies apply as stated.
            </p>
          </div>
          <div data-id="element-283">
            <h3 className="font-semibold text-base mb-2 text-teal-700" data-id="element-284">
              Additional Legal Disclosures
            </h3>
            <p data-id="element-285">
              THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
              CONSUMER PROTECTION UPDATE. MARKETING DISCLOSURE: This website is
              a marketplace. The owner may receive payment when a qualified lead
              is referred. ADVERTISING DISCLOSURE: This website and the products
              & services referred to on the site are advertising marketplaces.
              Any photographs of persons used on this site may be models.
            </p>
          </div>
        </div>
      </div>
    </section>;
};